// @ts-check

class FinstralHero extends HTMLElement {}

if (!customElements.get("finstral-hero")) {
	customElements.define("finstral-hero", FinstralHero);
}
